export const adminMenus = [
    {
        icon: 'fa-users',
        ref: 'Users',
        children: [
            {
                ref: 'Users',
                route: '/users',
            },
            {
                ref: 'Roles',
                route: '/roles',
            },
            {
                ref: 'Departments',
                route: '/departments',
            },
            {
                ref: 'Locations',
                route: '/locations',
            },
            {
                ref: 'BusinessUnits',
                route: '/business-units',
            },
        ],
    },
    {
        icon: 'fa-book-open',
        ref: 'Learning',
        children: [
            {
                ref: 'CompetencyAreas',
                route: '/competency-areas',
            },
            {
                ref: 'Competencies',
                route: '/competencies',
            },
            {
                ref: 'PositiveIndicators',
                route: '/positive-indicators',
                companySetting: c => c.development.usePositiveIndicators,
            },
            {
                ref: 'CompetencyRatingGroups',
                route: '/competency-rating-groups',
                companySetting: c => c.development.usePositiveIndicators,
            },
            {
                ref: 'Metrics',
                route: '/metrics',
                metricsOnly: true,
                module: 'integrations',
            },
            {
                ref: 'Goals',
                route: '/goals',
            },
            {
                ref: 'Pathways',
                route: '/pathways',
                module: 'pathways',
            },
        ],
    },
    {
        icon: 'fa-cog',
        ref: 'Config',
        children: [
            {
                ref: 'Configuration',
                route: '/config',
            },
            {
                ref: 'Integrations',
                route: '/integrations',
            },
            {
                ref: 'Tags',
                route: '/tags',
            },
            {
                ref: 'Languages',
                route: '/languages',
            },
        ],
    },
];
